import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import RawDetails from '@components/rawDetails/RawDetails';

import { RouteParams } from '@core/services/routingService/routingService';
import { demmiRequest } from '@helpers/app.helper';
import { getVendor } from '@core/services/networkService/_vendors';
import { DemmiFS } from '@subhanhabib/demmilib';

const VendorRaw: React.FC = () => {
  const { [RouteParams.VENDOR_ID]: vendorID } = useParams();
  const [vendor, setVendor] = useState<DemmiFS.VendorWithRaw>();

  useEffect(() => {
    refresh();
  }, [vendorID]);

  const refresh = () => {
    if (vendorID) {
      demmiRequest(getVendor(vendorID))
        .then(f => {
          if (f) setVendor(f);
        })
        .catch(() => {});
    }
  };

  return vendor ? <RawDetails data={vendor.raw} /> : <></>;
};

export default VendorRaw;
